export const breadcrumbMapArr = [
    {
        name: 'Home',
        link: '/dashboard'
    }
]

export const officeDaysArr = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"];

export const INITIAL_STATE = {
    requestDeliveryDate: "",
    type: "",
    interval: "",
    dayOfWeek: "",
    dayOfMonth: "",
    index: "",
    daysdropDown: "",
    theDayRadio: "",
    recurrenceRadio: "",
    noDay: "",
    start: "",
    endBy: "",
    endAfterOccurrences: "",
};

export const getPostingMethodPlaceHolder = (pageLanguageContents) => pageLanguageContents?.Arrow_MyPreferences[9]?.CommunityPlaceHolder2;

export const getPickUpDeliverableArr = (pageLanguageContents) => {
    return ([
        {
            value: "DELIVERABLE",
            label: pageLanguageContents?.Arrow_Delivery_Requirement[1]?.Delivery_OP1
        },
        {
            value: "PICK_UP",
            label: pageLanguageContents?.Arrow_Delivery_Requirement[2]?.Delivery_OP2
        },
    ])
};

export const getRecurrencePost = (pageLanguageContents) => {
    return ([
        {
            value: "POST",
            label: pageLanguageContents?.Arrow_Delivery_Requirement[5]?.Date_OP1_RButton
        },
        {
            value: "ORDER",
            label: pageLanguageContents?.Arrow_Delivery_Requirement[6]?.Date_OP2_RButton
        },
    ])
};

export const getNotesArr = (pageLanguageContents) => {
    return ([
        pageLanguageContents?.Arrow_Delivery_Requirement[16]?.Equipment_OP1,
        pageLanguageContents?.Arrow_Delivery_Requirement[17]?.Equipment_OP2,
        pageLanguageContents?.Arrow_Delivery_Requirement[18]?.Equipment_OP3,
    ])
};

export const getSellingArr = (pageLanguageContents) => {
    return ([
        {
            value: 'SplitByLot',
            label: 'Create one post per lot'
        },
        {
            value: 'sellAll',
            label: 'Create one post with all lots'
        },
    ])
};

export const getDropLiveState = (pageLanguageContents) => {
    return ([
        {
            value: "LIVE",
            label: pageLanguageContents?.Arrow_Delivery_Requirement[20]?.EqupUnload_OP1
        },
        {
            value: "DROP",
            label: pageLanguageContents?.Arrow_Delivery_Requirement[21]?.EqupUnload_OP2
        },
    ])
};

export const getAppointmentArr = (pageLanguageContents) => {
    return ([
        {
            value: "DELIVERY",
            label: pageLanguageContents?.Arrow_Delivery_Requirement[23]?.Appnt_OP1
        },
        {
            value: "APPOINTMENT",
            label: pageLanguageContents?.Arrow_Delivery_Requirement[24]?.Appnt_OP2
        },
    ])
};

export const getBidArr = (pageLanguageContents) => {
    return ([
        {
            value: "AUTO_ACCEPT_LOW_BID",
            label: pageLanguageContents?.Arrow_MyPreferences[2]?.Bid_OP1
        },
        {
            value: "MANUALLY_ACCEPT_BID",
            label: pageLanguageContents?.Arrow_MyPreferences[3]?.Bid_OP2
        },
    ])
};

export const getPostMethodArr = (pageLanguageContents) => {
    return ([
        {
            value: "MARKET",
            label: pageLanguageContents?.Arrow_MyPreferences[5]?.BidCommunity_OP1
        },
        {
            value: "GROUP",
            label: pageLanguageContents?.Arrow_MyPreferences[6]?.BidCommunity_OP2
        },
    ])
};

export const getPatternArr = (pageLanguageContents) => {
    return ([
        {
            value: 'DAILY',
            label: pageLanguageContents?.RecurrenceModal[13]?.Daily,
        },
        {
            value: 'WEEKLY',
            label: pageLanguageContents?.RecurrenceModal[14]?.Weekly,
        },
        {
            value: 'MONTHLY',
            label: pageLanguageContents?.RecurrenceModal[15]?.Monthly,
        },
    ])
};

export const getMonthlyArr = (pageLanguageContents) => {
    return ([
        {
            value: 'Day',
            label: pageLanguageContents?.RecurrenceModal[34]?.Day,
        },
        {
            value: 'The',
            label: pageLanguageContents?.RecurrenceModal[35]?.The,
        },
    ])
};

export const getDaysArr = (pageLanguageContents) => {
    return ([
        {
            value: 'MONDAY',
            label: pageLanguageContents?.RecurrenceModal[6]?.Day_B1,
        },
        {
            value: 'TUESDAY',
            label: pageLanguageContents?.RecurrenceModal[7]?.Day_B2,
        },
        {
            value: 'WEDNESDAY',
            label: pageLanguageContents?.RecurrenceModal[8]?.Day_B3,
        },
        {
            value: 'THURSDAY',
            label: pageLanguageContents?.RecurrenceModal[9]?.Day_B4,
        },
        {
            value: 'FRIDAY',
            label: pageLanguageContents?.RecurrenceModal[10]?.Day_B5,
        },
        {
            value: 'SATURDAY',
            label: pageLanguageContents?.RecurrenceModal[11]?.Day_B6,
        },
        {
            value: 'SUNDAY',
            label: pageLanguageContents?.RecurrenceModal[12]?.Day_B7,
        },
    ])
};

export const getCountDropDownArr = (pageLanguageContents) => {
    return ([
        {
            label: pageLanguageContents?.RecurrenceModal[16]?.First,
            value: 'FIRST',
        },
        {
            label: pageLanguageContents?.RecurrenceModal[17]?.Second,
            value: 'SECOND',
        },
        {
            label: pageLanguageContents?.RecurrenceModal[18]?.Third,
            value: 'THIRD',
        },
        {
            label: pageLanguageContents?.RecurrenceModal[19]?.Fourth,
            value: 'FOURTH',
        },
        {
            label: pageLanguageContents?.RecurrenceModal[20]?.Last,
            value: 'LAST',
        },
    ])
};

export const getDaysDropDownArr = (pageLanguageContents) => {
    return ([
        {
            label: pageLanguageContents?.RecurrenceModal[21]?.Mon,
            value: 'MONDAY',
        },
        {
            label: pageLanguageContents?.RecurrenceModal[22]?.Tue,
            value: 'TUESDAY',
        },
        {
            label: pageLanguageContents?.RecurrenceModal[23]?.Wed,
            value: 'WEDNESDAY',
        },
        {
            label: pageLanguageContents?.RecurrenceModal[24]?.Thu,
            value: 'THURSDAY',
        },
        {
            label: pageLanguageContents?.RecurrenceModal[25]?.Fri,
            value: 'FRIDAY',
        },
        {
            label: pageLanguageContents?.RecurrenceModal[26]?.Sat,
            value: 'SATURDAY',
        },
        {
            label: pageLanguageContents?.RecurrenceModal[27]?.Sun,
            value: 'SUNDAY',
        },
    ])
};

export const getDeliveryTimeArr = (pageLanguageContents) => {
    return ([
        {
          id: "0",
          label: "No Lead Time",
          value: "1",
        },
        {
          id: "1",
          label: "24",
          value: "24",
        },
        {
          id: "2",
          label: "48",
          value: "48",
        },
        {
          id: "3",
          label: "72",
          value: "72",
        }
      ])
};

export const getDeliveryAvailableArr = (pageLanguageContents) => {
    return ([
        {
          value: "true",
          label:pageLanguageContents?.Arrow_Delivery_Requirement[2]?.Available_OP1,
        },
        {
          value: "false",
          label:pageLanguageContents?.Arrow_Delivery_Requirement[3]?.Available_OP2,
        },
      ])
};

export const getVehiclePreferences = (pageLanguageContents) => {
    return ([
        pageLanguageContents?.Arrow_Delivery_Requirement[5]?.Equipment_OP1,
        pageLanguageContents?.Arrow_Delivery_Requirement[6]?.Equipment_OP2,
        pageLanguageContents?.Arrow_Delivery_Requirement[7]?.Equipment_OP3,
      ])
};

export const getSellingArrInv = (pageLanguageContents) => {
    return ([
        {
          value: "SplitByLot",
          label: pageLanguageContents?.Arrow_Price[5]?.LotsSell_OP1,
        },
        {
          value: "sellAll",
          label: pageLanguageContents?.Arrow_Price[7]?.LotsSell_OP2,
        },
      ])
};

export const getBidArrInv = (pageLanguageContents) => {
    return ([
        {
          value: "ABOVE_TARGET_THRESHOLD",
          label: pageLanguageContents?.Arrow_MyPreferences[3]?.Bid_OP1,
        },
        {
          value: "APPROVE_AND_ACCEPT",
          label: pageLanguageContents?.Arrow_MyPreferences[4]?.Bid_OP2,
        },
      ])
};

export const getPostMethodArrInv = (pageLanguageContents) => {
    return ([
        {
          value: "MARKET",
          label: pageLanguageContents?.Arrow_MyPreferences[6]?.BidCommunity_OP1,
        },
        {
          value: "GROUP",
          label: pageLanguageContents?.Arrow_MyPreferences[7]?.BidCommunity_OP2,
        },
      ])
};

export const getRecurrencePostInv = (pageLanguageContents) => {
    return ([
        {
          value: "POST",
          label: "Recurring Post: Schedule this post to automatically recreate daily, weekly or monthly needs.",
        },
      ])
};